import { createWebHistory, createRouter } from "vue-router";
import {$config} from "@/tenants/config"
import {$session} from "@/dot-ui";

// ---------------------------------
// 멀티 테넌트 routes 설정
// ---------------------------------
const routes = $config.getRoutes();
const WHITE_LIST = [
	"login",
	"find-ID",
	"find-password",
	"join",
];

export const router = createRouter({
	history: createWebHistory(),
	routes,
});

// -----------------------------
// 전역 로그인 체크 가드
// -----------------------------
router.beforeEach(async (to, from, next) => {
	if (WHITE_LIST.includes(to.name)) {
		next();
		return;
	}

	const ok = await $session.ensureLoggedIn();
	if (!ok) {
		next({ name: "login" });
		return;
	}

	next();
});